import { render } from "./BaseSubmenu.vue?vue&type=template&id=7ec3df6c&scoped=true"
import script from "./BaseSubmenu.vue?vue&type=script&lang=js"
export * from "./BaseSubmenu.vue?vue&type=script&lang=js"

import "./BaseSubmenu.vue?vue&type=style&index=0&id=7ec3df6c&scoped=true&lang=css"
import "./BaseSubmenu.vue?vue&type=style&index=1&id=7ec3df6c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec3df6c"]])

export default __exports__